import Box from '@mui/joy/Box'
import Input from '@mui/joy/Input'
import Chip from '@mui/joy/Chip'

const DynamicChip = () => (
    <Chip size="sm" variant="soft" color="primary">
        dynamic
    </Chip>
)

const StaticChip = () => (
    <Chip size="sm" variant="soft" color="neutral">
        static
    </Chip>
)

const Layer = ({ layer, onChange, selected }) => {
    let chip =
        layer.type.startsWith('template') || layer.type.startsWith('prompt') ? (
            <DynamicChip />
        ) : (
            <StaticChip />
        )
    return (
        <Input
            startDecorator={chip}
            type="text"
            onChange={onChange}
            variant="outlined"
            color={selected ? 'primary' : 'neutral'}
            defaultValue={layer.name}
        />
    )
}

export const LayerList = ({ layers, onChange, selected }) => {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            {layers.map((layer) => (
                <Layer
                    key={layer.id}
                    layer={layer}
                    onChange={(e) => onChange(layer, e.target.value)}
                    selected={selected && layer.id === selected.id}
                />
            ))}
        </Box>
    )
}
